import { NgModule } from '@angular/core';
import { AccountBillingManagerModule } from './account-billing-manager.module';
import { AccountBillingManagerRoutingModule } from './account-billing-manager.routing';

@NgModule({
    imports: [AccountBillingManagerModule, AccountBillingManagerRoutingModule],
    declarations: [],
    exports: [],
    providers: []
})
export class AccountBillingManagerRoutetownModule {}
